"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itauCnabRequestSchema = exports.PaymentCnabSchema = exports.ItauTransferType = exports.ItauPixKeyType = void 0;
const zod_1 = require("zod");
const string_fns_1 = require("./utils/string.fns");
const common_1 = require("./common");
const DateRegex = /^\d{4}-\d{2}-\d{2}$/;
exports.ItauPixKeyType = {
    phone: '01',
    email: '02',
    cpf_or_cnpj: '03',
    random: '04',
};
exports.ItauTransferType = {
    checking_account: '01',
    payment_account: 'PG',
    savings_account: '03',
    pix_key: '04',
};
const itauCnabContext = zod_1.z.object({
    type: zod_1.z.literal('cnab'),
});
const itauCnabAccountPaymentSchema = zod_1.z.object({
    type: zod_1.z.literal('account'),
    bank_code: zod_1.z.coerce.number().min(1, 'O código do banco é inválido'),
    branch: zod_1.z.coerce.number().min(1, 'O número da agência é inválido'),
    account: zod_1.z.coerce.number().min(1, 'O número da conta é inválido'),
    account_digit: zod_1.z.coerce.number().min(0, 'O dígito da conta é inválido').optional().default(0),
    account_type: zod_1.z
        .union([
        zod_1.z.literal('checking_account'),
        zod_1.z.literal('payment_account'),
        zod_1.z.literal('savings_account'),
        zod_1.z.literal('pix_key'),
    ])
        .default('checking_account'),
});
exports.PaymentCnabSchema = zod_1.z.object({
    creditor_name: zod_1.z.string().min(1),
    amount: zod_1.z.number().min(0.01),
    cpf_or_cnpj: string_fns_1.cpfCnpjValidator,
    payment_date: zod_1.z
        .string()
        .optional()
        .refine(val => {
        if (!val)
            return true;
        return val.match(DateRegex);
    }, { message: 'Data de pagamento inválida' }),
    my_number: zod_1.z.string().optional(),
    external_creditor_id: zod_1.z.string().optional(),
    transfer: zod_1.z.discriminatedUnion('type', [common_1.TransferByPixKeySchema, itauCnabAccountPaymentSchema]),
    payroll_checkout_id: zod_1.z.number().optional(),
});
const itauCnabCompanySchema = zod_1.z.object({
    name: zod_1.z.string().min(1),
    branch: (0, string_fns_1.stringAsNum)(),
    account: (0, string_fns_1.stringAsNum)(),
    account_digit: (0, string_fns_1.stringAsNum)(),
    cnpj: string_fns_1.cpfCnpjValidator.transform(Number),
    address_street: zod_1.z.string().min(1),
    address_number: zod_1.z.number(),
    address_complement: zod_1.z.string().optional(),
    address_city: zod_1.z.string().min(1),
    address_zip_code: zod_1.z.string().min(1),
    address_state: zod_1.z.string().min(1),
});
exports.itauCnabRequestSchema = zod_1.z.object({
    bankCode: zod_1.z.string().min(1).max(3),
    payment_date: zod_1.z
        .string()
        .optional()
        .refine(val => {
        if (!val)
            return true;
        return val.match(DateRegex);
    }, { message: 'deve ser uma data' }),
    company: itauCnabCompanySchema,
    payments: zod_1.z.array(exports.PaymentCnabSchema).min(1),
    context: itauCnabContext,
});
